<app-popup-frame [header]="'Delete Payment Credentials'" status="danger" [actions]="actions" (action)="actionClick($event)" [loading]="loading">
    <div class="main">
        Delete your PayPal credentials from the cloud.
        <br/><br/>
        All apps and features which require Payments will immediately stop functioning.
        <br/>
        <br/>
        <b>Are you sure you want to delete your PayPal credentials?</b>
    </div>
</app-popup-frame>